import getStoreModuleByName from "./getStoreModuleByName";
/**
 * @param {object} modules
 * @param {object} store Vuex store object
 */
export default function registerStoreModules(modules, store) {
  for (let module_key in modules) {
    store.registerModule(getStoreModuleByName(module_key), modules[module_key]);
  }
}
